import { useEffect } from 'react';

import { TechnographicsResults } from 'features/technographics';
import { setHeaderTitle } from 'widgets/Header';
import { useAppDispatch } from 'store';

import styles from './index.module.scss';

export const TechnographicsResultsPage = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(setHeaderTitle(''));
	}, [dispatch]);

	return (
		<div className={styles.container}>
			<TechnographicsResults />
		</div>
	);
};
